//deps
import React from "react";

//context
import { LinkWalletContext } from "@payment-client/contexts/LinkWalletContext";

export function LinkWalletContextProvider<T extends { children?: React.ReactNode }>(props: T): React.ReactElement {
    const [linkWalletState, setLinkWalletState] = React.useState({ mobileNumber: "" });

    const linkWalletContextValue = React.useMemo(
        () => ({
            linkWalletState,
            setLinkWalletState,
        }),
        [linkWalletState],
    );

    return <LinkWalletContext.Provider value={linkWalletContextValue}>{props.children}</LinkWalletContext.Provider>;
}
